<template>
    <div class="container">
        <el-table :data="data" header-cell-class-name="header-cell-style" header-row-class-name="header-row-style"
            cell-class-name="cell-style" row-class-name="row-style" stripe height="100%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100" ></el-table-column>
            <el-table-column prop="deviceName" label="名称"></el-table-column>

            <template v-if="deviceClassify === '配电设备'">
                <el-table-column prop="type" label="设备类型" key="1"></el-table-column>
            </template>

            <el-table-column prop="modelNumber" label="型号"></el-table-column>
            <el-table-column prop="siteName" label="所属站点"></el-table-column>

            <template v-if="deviceClassify === '网关设备'">
                <el-table-column prop="status" label="通讯状态" key="2">
                    <template slot-scope="scope">
                        <div class="img-wrapper">
                            <img v-if="eBoxStatus.includes(scope.row.mac)" :src="require('../../../assets/img/在线.png')"
                                alt="" />
                            <img v-else :src="require('../../../assets/img/离线.png')" />
                        </div>
                    </template>
                </el-table-column>
            </template>

            <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row, eBoxStatus)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>

            <template v-slot:empty>
                <img :src="require('../../../assets/img/not_found_data.png')">
            </template>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
            },
            deviceClassify: String,
        },
        methods: {
            handleClick(row, eBoxStatus) {
                this.$emit('showDetail', row, eBoxStatus.includes(row.mac));
            },
        },
        computed: {
            eBoxStatus() {
                // console.log(this.$store.getters.eBoxInfo, this.data);
                return this.$store.getters.eBoxInfo()
                    .filter(item => item.online && item.projectName == this.$store.state.project.projectInfo.influxDbName)
                    .map(item => item.deviceId);
            }
        },
    }
</script>

<style lang="less" scoped>
    .container {
        height: 100%;

        .img-wrapper {
            // max-height: 33rem;
            img{
                max-width: 47rem;
            }
        }
    }
</style>